import { render, staticRenderFns } from "./ConfettiCircle.vue?vue&type=template&id=927f483e&lang=pug&"
import script from "./ConfettiCircle.vue?vue&type=script&lang=js&"
export * from "./ConfettiCircle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports